import { render, staticRenderFns } from "./OrmMessageListSideMenu.vue?vue&type=template&id=5712bcd9&scoped=true"
import script from "./OrmMessageListSideMenu.vue?vue&type=script&lang=js"
export * from "./OrmMessageListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./OrmMessageListSideMenu.vue?vue&type=style&index=0&id=5712bcd9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5712bcd9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5712bcd9')) {
      api.createRecord('5712bcd9', component.options)
    } else {
      api.reload('5712bcd9', component.options)
    }
    module.hot.accept("./OrmMessageListSideMenu.vue?vue&type=template&id=5712bcd9&scoped=true", function () {
      api.rerender('5712bcd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormmessage/OrmMessageListSideMenu.vue"
export default component.exports